module.exports = __webpack_public_path__ + "static/social-share-f36b7ce0d96137777894e2a89c5ef894.png";